import axios from "axios"
import { useAuth0 } from "@auth0/auth0-react"
import { useQuery } from "@tanstack/react-query"
import { useDispatch, useSelector } from "react-redux"
import { setCenter } from "../features/settings/settingsSlice"

const useFetchCenters = () => {
	const dispatch = useDispatch()
	const { getAccessTokenSilently, isAuthenticated } = useAuth0()
	const currentCenter = useSelector(state => state.settings.center)

	const { data } = useQuery({
		queryKey: ["centers"],
		queryFn: async () => {
			const token = await getAccessTokenSilently({
				authorizationParams: { audience: process.env.REACT_APP_API_IDENTIFIER }
			})
			const response = await axios.get(
				`${process.env.REACT_APP_BACKEND_URL}/api/centers`,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			// Auto-select the first center if the user hasn't picked one yet.
			// The selected-center is UI state (drives location filters across
			// pages) so it lives in Redux; the array of centers itself comes
			// from the React Query cache.
			if (!currentCenter && response.data.length > 0) {
				dispatch(setCenter(response.data[0]))
			}
			return response.data
		},
		enabled: isAuthenticated,
		staleTime: 1000 * 60 * 30,
		refetchOnMount: "always"
	})

	return data ?? []
}

export default useFetchCenters
